/**
 * ブランドLPのモーダルイベントを登録する
 * 教室モーダルや口コミ絞り込みモーダルの開閉処理を設定
 */
function registModalEvent() {
	let Modal = {
		/** モーダルコンテンツ高さ、幅(%) */
	
		/** 
		 * モーダルを開く共通処理
		 * @param clickElement モーダルを開くボタン
		 * @param modalElement  モーダルの枠(class="js-modal-window")
		 * @param beforeFunc オーバーレイ表示前に実行する関数
		 * @param afterFunc オーバーレイ表示後に実行する関数
		 */
		open: function(clickElement, modalElement, beforeFunc, afterFunc) {
			// スクロール位置保存、固定
			this._lockScroll();
			// 前処理
			if (typeof(beforeFunc) === 'function') beforeFunc(clickElement, modalElement);
			// オーバーレイ表示
			modalElement.children('.js-modal-window-box').fadeIn('fast', function(){
				// 後処理
				if (typeof(afterFunc) === 'function') afterFunc(clickElement, modalElement);
			});
		},
		
		/** 
		 * モーダルを閉じる共通処理
		 * @param beforeFunc オーバーレイ非表示前に実行する関数
		 * @param afterFunc オーバーレイ非表示後に実行する関数
		 */
		close: function(beforeFunc, afterFunc) {
			// 前処理
			if (typeof(beforeFunc) === 'function') beforeFunc();
			// オーバーレイ非表示
			$('.js-modal-window-box:visible').fadeOut();
			// モーダルの中身非表示
			$('.js-modal-window-box-inner:visible').fadeOut();
			// 後処理
			if (typeof(afterFunc) === 'function') afterFunc();
			// スクロール位置復元、固定解除
			this.unlockScroll();
		},
		
		/** 
		 * スクロール位置保存、固定
		 */
		_lockScroll: function() {
			$('body').css('overflow', 'hidden');
		},
		
		/** 
		 * スクロール固定解除、位置復元
		 */
		unlockScroll: function() {
			$('body').css('overflow', '');
		}
	};

	/** 教室モーダル 開くイベント */
	$(document).on('click', '.js-brandlp-modal-window-btn', function(){
		Modal.open(
			$(this),
			$(this).closest('.js-modal-window'),
			function(clickElement, modalElement){
				// loading画像表示
				if (typeof(loadingPopup) == 'function') {
					loadingPopup();
				}
				// データ取得
				var dataUrl = clickElement.data('url');
				$.ajax({
					type: 'POST',
					url: dataUrl,
					datatype: 'json',
					cache: false,
				}).done(function(data) {
					modalElement.find('.js-modal-window-cont-iframe').html(data.response);
					// loading画像非表示
					$('body').find('.js-loading-popup').remove();
					// js-modal-window-box-innerを画面中央に配置するための幅の調整
					var modalLeft = Math.floor(($(window).width() - modalElement.children(".js-modal-window-box-inner").width()) / 2);
					var modalTop = Math.floor(($(window).height() - modalElement.children(".js-modal-window-box-inner").height()) / 2);
					modalElement.children(".js-modal-window-box-inner").css({"top":modalTop, "left":modalLeft });
					// モーダルコンテンツ表示
					modalElement.children('.js-modal-window-box-inner').show();
					// ajaxで取得するためイベントを再登録する
					trackEvent.bindEventOnElements(modalElement.find('.js-modal-window-cont-iframe'));
				}).fail(function () {
					$('body').find('.js-loading-popup').remove();
					$('.js-modal-window-box:visible').hide();
					// 失敗した場合はスクロールロックを解除
					Modal.unlockScroll();
					alert('データを取得できませんでした。');
				});
			},
			null
		);
	});

	/** 教室モーダル 閉じるイベント(オーバーレイ) */
	$(document).on('click', '.js-modal-window-box, .js-brandlp-modal-iframe-close', function(){
		if ($('.js-modal-window-box').is(':visible') && $('.js-modal-window-box-inner').is(':visible') && $('body').find('.js-loading-popup').length == 0) {
			Modal.close();
		}
	});

	// 口コミ絞り込みの教室選択モーダルを開く
	$(document).on('click', '.js-review-search-button', function() {
		$('#js-review-search-box').trigger('click');
	});
	// 資料請求先の教室選択モーダルを開く
	$(document).on('click', '.js-cv-search-button', function() {
		// モーダルCVボタンのリスト名を変更
		$('.js-cv-button').attr('list_name', $(this).attr('list_name'));
		$('#js-cv-search-box').trigger('click');
	});
}

/**
 * 資料請求ボタンのイベントを登録する
 * クリック時にeコマーストラッキング送信とカートフォーム送信を実行
 */
function registCvButton(){
	// 資料請求をするボタンをクリック
	$('.js-form-cart-submit-btn').on('click', function() {
		let prefCd = '';
		let addKoushaId = '';
		let isBrandLp = (location.pathname.indexOf('/brandlp1/') !== -1);
		if (isBrandLp) {
			// ブランドLP（教室絞り込みあり）の場合、選択されている教室IDを設定
			addKoushaId = $('.js-kousha-selector-kousha').val();
			if ($('.js-kousha-button').hasClass('js-kousha-selector-disabled') || addKoushaId == "") {
				// 資料請求をするボタンが無効、もしくは教室IDがない場合なにもしない
				return;
			}
			prefCd = $('.js-kousha-selector-pref').val();
		} else {
			// 教室LPの場合、CVボタンのデータ属性を設定
			prefCd = $(this).attr('data-pref_cd');
			addKoushaId = $(this).attr('data-kousha_id');
		}
		
		// eコマースカート追加送信
		const listName = $(this).attr('list_name');
		const listPosition = $(this).attr('list_position') !== undefined ? $(this).attr('list_position') : '';
		const jukuId = $(this).attr('data-juku_id');
		const ecItem = {
			'item_id': 'b' + jukuId + '_k' + addKoushaId,
			'item_brand': 'b' + jukuId,
			'item_category': 'p' + prefCd,
			'price': 4000,
			'currency': 'JPY',
			'item_list_name': listName,
			'index': listPosition,
			'quantity': 1
		};
		gtag('event', 'add_to_cart', {
			'currency': 'JPY',
			'value': 4000,
			'items': [ecItem]
		});

		gtag('event', 'cart', {
			"TheEventAction": "click",
		});

		// カート追加情報を追加
		let html = '';
		html += '<input type="hidden" name="chk_kousha" value="' + addKoushaId + '">';
		html += '<input type="hidden" name="list_name" value="' + listName + '">';
		html += '<input type="hidden" name="index" value="' + listPosition + '">';

		// via_pageパラメーター付与
		html += '<input type="hidden" name="via_page" value="brandLp1">';

		$('#js-form-cart-brandlp-kousha').append(html);

		// カートページへ遷移
		$('#js-form-cart-brandlp-kousha').submit();

		// JSでページ遷移を制御するため、デフォルトのクリック動作を抑止（Firefoxでブラウザバック時の履歴が正しく保持されない事象への対応）
		return false;
	});
}

/**
 * ページロード後に処理を走らせる
 */
$(function(){
	registModalEvent();
	registCvButton();
});